export const ALIGNMENT_STATUS_LABELS = {
  PENDING: "In coda",
  RUNNING: "Analisi batch in corso",
  ANALYZING: "Analisi in corso",
  READY: "Azioni pronte",
  PARTIAL_READY: "Pronto con dati parziali",
  BLOCKED: "Bloccato",
  ERROR: "Errore",
  NO_ACTIONS: "Nessuna azione",
  APPROVED: "Approvato",
  APPLYING: "Applicazione in corso",
  WAITING_REVIEW: "In attesa di revisione",
  WAITING_DOWNSTREAM: "In attesa di Prestashop",
  SUCCESS: "Completato",
  PARTIAL_SUCCESS: "Completato parzialmente",
  STALE: "Analisi non piu attuale",
  CONFLICT: "Conflitto",
  CANCELLED: "Annullato",
};

export function alignmentStatusLabel(status) {
  return ALIGNMENT_STATUS_LABELS[status] || status || "Non disponibile";
}

export function semanticTextLabel(fieldPath) {
  const value = String(fieldPath || "");
  if (value.includes("descBreve")) return "Descrizione breve VIG/partner";
  if (value.includes("descIntro")) return "Introduzione Bottero";
  if (value.includes("descLunga")) return "Descrizione lunga";
  if (value.includes("titolo")) return "Titolo prodotto";
  return value || "Testo";
}

export function actionMetadata(action) {
  if (action?.metadata && typeof action.metadata === "object") return action.metadata;
  const diagnostics = action?.diagnostics;
  if (!diagnostics || typeof diagnostics !== "object") return {};
  return diagnostics.metadata && typeof diagnostics.metadata === "object"
    ? diagnostics.metadata
    : {};
}

export function plannedActionStatus(action) {
  return action?.diagnostics?.plannedStatus || action?.plannedStatus || action?.status || "PROPOSTA";
}

export function findingDetails(finding) {
  const parsed = finding?.details;
  if (!parsed || typeof parsed !== "object") return {};
  return parsed.details && typeof parsed.details === "object" ? parsed.details : parsed;
}

function countPresentLeaves(value) {
  if (Array.isArray(value)) return value.filter((item) => item !== null && typeof item !== "undefined").length;
  if (!value || typeof value !== "object") return value === null || typeof value === "undefined" || value === "" ? 0 : 1;
  return Object.values(value).reduce((total, item) => total + countPresentLeaves(item), 0);
}

export function sourceComparison(snapshot, sourceName) {
  if (sourceName === "DOMINO") {
    const domino = snapshot?.domino || {};
    const vigCategories = Array.isArray(domino.categorieWebAssociate) ? domino.categorieWebAssociate : [];
    const botCategories = Array.isArray(domino.categorieWebBotteroAssociate) ? domino.categorieWebBotteroAssociate : [];
    return {
      texts: domino.descrizioniSuPS || {},
      features: domino.datiUlteriori || {},
      categories: {
        associatedVig: vigCategories,
        associatedBot: botCategories,
        defaultVig: domino.categoriaPredefinita ?? null,
        defaultBot: domino.categoriaBotteroPredefinita ?? null,
      },
      images: domino.immagini || domino.images || [],
      counts: {
        texts: countPresentLeaves(domino.descrizioniSuPS),
        features: countPresentLeaves(domino.datiUlteriori),
        categories: vigCategories.length + botCategories.length,
        images: Array.isArray(domino.immagini || domino.images) ? (domino.immagini || domino.images).length : 0,
      },
    };
  }
  const site = snapshot?.sites?.[sourceName] || {};
  const categories = Array.isArray(site.categories)
    ? site.categories
    : site.categories?.associatedIds || site.categories?.categoryIds || [];
  return {
    texts: site.dominoTexts || site.texts || {},
    features: site.features || [],
    categories: site.categories || [],
    images: site.images || [],
    diagnostics: site.diagnostics || [],
    counts: {
      texts: countPresentLeaves(site.dominoTexts || site.texts),
      features: Array.isArray(site.features) ? site.features.length : countPresentLeaves(site.features),
      categories: Array.isArray(categories) ? categories.length : 0,
      images: Array.isArray(site.images) ? site.images.length : 0,
    },
  };
}

export function actionLabel(action) {
  if (action?.domain === "TEXT") return semanticTextLabel(action.field_path || action.fieldPath);
  const fieldPath = action?.field_path || action?.fieldPath;
  return fieldPath || action?.action_type || action?.operation || action?.domain || "Azione";
}

export function countActionsByDomain(actions) {
  return (Array.isArray(actions) ? actions : []).reduce((result, action) => {
    if (actionMetadata(action).approvalRole === "PROPAGATION") return result;
    const domain = action?.domain || "ALTRO";
    result[domain] = (result[domain] || 0) + 1;
    return result;
  }, {});
}

export function siteState(snapshot, site) {
  const value = snapshot?.sites?.[site];
  if (!value) return { label: "Non rilevato", tone: "muted" };
  if (value.available === false) return { label: "Non interrogabile", tone: "error" };
  if (value.partial) return { label: "Dati parziali", tone: "warning" };
  return { label: "Disponibile", tone: "ready" };
}

export function buildAlignmentItemHref(itemId) {
  return `/allineamentoPrestashop?itemId=${encodeURIComponent(String(itemId))}`;
}

export function asDisplayValue(value) {
  if (value === null || typeof value === "undefined" || value === "") return "—";
  if (typeof value === "string") return value;
  return JSON.stringify(value, null, 2);
}
